// src/theme/index.ts
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: 'rgb(0, 128, 201)',
    },
    secondary: {
      main: '#194B7D',
    },

    success: {
      main: 'rgb(141, 176, 0)',
      light: '#A2CC00',
    },
    error: {
      main: 'rgb(213, 0, 0)',
    },
    background: {
      default: 'rgb(219, 241, 251)',
    },
  },
});
